/* c8 ignore next 20 */
const browserStackURL = location.host.includes('bs-local.com');
const notInIframe = window.self === window.top;
const shouldRaiseError = !browserStackURL && notInIframe && !crypto.subtle;

if (shouldRaiseError) {
  throw new Error(
    `crypto.subtle is not working!

    🟡 crypto.subtle is only enabled in secure environments.

          - https://developer.mozilla.org/en-US/docs/Web/API/Crypto/subtle
          - https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts

    🟢 To fix the problem you must open browser on:
        - https
        - localhost
        - 127.0.0.1
    `
  );
}
